//
// VisualPromptContainerElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualContainerElementController";
import "../../models/visualElements/VisualPromptContainerElement";

var VisualPromptContainerElementController = createModule("BIRD::VisualPromptContainerElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController","BIRD::VisualContainerElementController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getModel: [1],
        applyDeferredPromptValues: [0],
        setActive: [0,2],
        savePromptsDataValues: [0],
        cancelDeferredPromptValues: [0],
        triggerInteractions: [0],
        isActionEnabled: [2],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default VisualPromptContainerElementController;
